import { PHONE, locationSchema } from "../structured-data-core";

export function getBeverlyHillsStructuredData() {
  const url = "https://restorehair.com/locations/california/beverly-hills/";
  const description =
    "Find out about your hair transplant options in Beverly Hills with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Beverly Hills", "9201 W Sunset Boulevard, Suite 812", "West Hollywood", "CA", PHONE, url, description),
  ];
}
